import { Layers, Smartphone, Server, Rocket, Briefcase, Compass, Check } from "lucide-react";
import { Reveal, SectionHeader } from "./shared";
import { services } from "../../data/portfolioData";

const icons = { Layers, Smartphone, Server, Rocket, Briefcase, Compass };

export const ServicesGrid = () => (
  <section id="services" className="py-20 lg:py-28 bg-[#090C13]" data-testid="services-grid-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <SectionHeader
        index="02"
        eyebrow="Capabilities"
        title="How I Can Help"
        description="From a rough idea to a production system — these are the ways I work with teams, founders and businesses."
        testId="services-header"
      />
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-6">
        {services.map((s, i) => {
          const Icon = icons[s.icon] || Layers;
          return (
            <Reveal key={s.title} delay={(i % 3) * 0.1}>
              <div
                className="group relative h-full rounded-2xl border border-white/[0.07] bg-[#0F1420] p-7 overflow-hidden transition-all duration-500 hover:border-amber-400/25 hover:-translate-y-1.5 hover:shadow-[0_20px_50px_-20px_rgba(0,0,0,0.7)]"
                data-testid={`service-card-${i}`}
              >
                <div className="absolute -top-16 -right-16 h-36 w-36 rounded-full bg-amber-500/0 blur-3xl transition-all duration-700 group-hover:bg-amber-500/10" />
                <div className="inline-flex rounded-xl border border-white/[0.08] bg-white/[0.04] p-3 text-amber-400 transition-transform duration-500 group-hover:scale-110">
                  <Icon size={22} strokeWidth={1.8} />
                </div>
                <h3 className="mt-5 font-display text-xl font-semibold tracking-tight text-slate-100">{s.title}</h3>
                <p className="mt-2.5 text-sm text-slate-400 leading-relaxed">{s.description}</p>
                <ul className="mt-5 space-y-2">
                  {s.deliverables.map((d) => (
                    <li key={d} className="flex items-center gap-2 text-xs text-slate-500">
                      <Check size={12} className="text-emerald-400 shrink-0" /> {d}
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
